/**
 * The user ids to look up an innlogging sub for, labelled by the token claim
 * each sub came from: `sub` for the user, `via_sub` (short for `nrk/via_sub`)
 * for the parent account a child profile acts through.
 */
export const subLookups = (userId: string, viaUserId?: string | null) => [
  { label: 'sub', userId },
  ...(viaUserId != null ? [{ label: 'via_sub', userId: viaUserId }] : []),
];
